





const isNode = typeof window === 'undefined';

const searchToQuery = (search) => {
  const query = {};
  const pairs = search && search.slice(1).split('&') || [];
  pairs.forEach(pair => {
    const tokens = pair.split('=');
    query[tokens[0]] = tokens[1];
  });
  return query;
};

const queryToSearch = (query) => {
  const pairs = ((query && Object.keys(query)) || {}).map(key => `${key}=${query[key]}`) || [];
  return `?${pairs.join('&')}`;
};

const formatUrl = (o) => {
  o.search = queryToSearch(o.query);
  return o.toString();
};

const parseUrl = (s) => {
  const anchor = document.createElement('a');
  anchor.href = s;
  anchor.query = searchToQuery(anchor.search);
  return anchor;
};

const defaultUrlLib = {
  formatUrl,
  parseUrl
};

const omit = (src, keys) => {
  const o = {};
  Object.keys(src).forEach((key) => {
    if (keys.indexOf(key) === -1) {
      o[key] = src[key];
    }
  });
  return o;
};

const filterNull = obj => {
  const filtered = {};
  Object.keys(obj || {}).forEach(key => {
    const value = obj[key];
    if (value) {
      filtered[key] = value;
    }
  });
  return Object.keys(filtered).length ? filtered : null;
};

module.exports = function (urlLib) {
  urlLib = urlLib || defaultUrlLib;








  const applyCampaignCodes = function (href, scsCampCode, subCampCode) {
    if (href && (href.indexOf('javascript:') === -1) && (href.indexOf('tel:') === -1) && (href.indexOf('#') !== 0)) {
      const linkUrl = urlLib.parseUrl(href);
      if (scsCampCode) {
        linkUrl.query = Object.assign({}, linkUrl.query, {
          scsCampCode: scsCampCode,
          subCampCode: scsCampCode
        });
      } else if (subCampCode) {
        linkUrl.query = Object.assign({}, linkUrl.query, {
          subCampCode: subCampCode
        });
        delete linkUrl.query.scsCampCode;
      }
      return urlLib.formatUrl(linkUrl);
    }
    return href;
  };

  const applyAffiliateCode = function (href, response, prefix) {
    const loanPurposeMap = {
      PropertyPurchase: 'purchase',
      Refinance: 'refinance',
      EquityRelease: 'homeEquity'
    };
    response = Object.assign({}, response, {
      loanPurpose: loanPurposeMap[response.loanPurpose]
    });
    if (href && (href.indexOf('javascript:') === -1) && (href.indexOf('tel:') === -1) && (href.indexOf('#') !== 0)) {
      prefix = prefix || '';
      href = `${prefix}${href}`;
      if (response && Object.keys(response).length) {
        const affiliateCode = response.affiliateCode;
        const debugging = response.debugging;
        const urlObject = urlLib.parseUrl(href);
        if (/applynow/.test(href)) {
          const phone = response.phoneNumber && response.phoneNumber.replace(/[^\d]+/g, '');
          urlObject.query = filterNull(Object.assign({}, urlObject.query, omit(response, ['phoneNumber']), {phone}));
        } else {
          urlObject.query = filterNull(Object.assign({}, urlObject.query, {debugging, affiliateCode}));
        }
        return urlObject.query ? urlLib.formatUrl(urlObject) : href;
      }
    }
    return href;
  };

  return Object.assign({}, urlLib || defaultUrlLib, {
    applyCampaignCodes,
    applyAffiliateCode
  });
};
